export default __webpack_public_path__ + "static/media/conformation.108a7b66.svg";